<template>
  <div
    :class="inlineSpinner ? 'd-inline-block' : 'd-flex justify-content-center'"
  >
    <div
      class="spinner-border text-secondary"
      :class="`spinner-border-${spinnerType}`"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
    <div v-if="loadingText" class="loading-text">{{ loadingText }}</div>
  </div>
</template>
<script>
export default {
  name: 'MSpinner',
  props: {
    spinnerType: {
      type: String,
      default: '',
    },
    loadingText: {
      type: String,
      default: '',
    },
    inlineSpinner: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.d-flex {
  &.justify-content-center {
    align-items: center;
    .spinner-border {
      &.spinner-border-xl {
        width: 5rem;
        height: 5rem;
        border-width: 0.4rem;
      }
    }
    .loading-text {
      margin-left: 8px;
    }
  }
}
</style>
